import { BrowserModule }                            from '@angular/platform-browser';
import { BrowserAnimationsModule }                  from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule, LOCALE_ID }        from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule }                         from '@angular/common/http';

import { TooltipsModule }                           from 'ionic-tooltips';

import { NgDatepickerModule }                       from 'ng2-datepicker';

import { MyApp }                                    from './app.component';

import { StatusBar }                                from '@ionic-native/status-bar';
import { SplashScreen }                             from '@ionic-native/splash-screen';
import { Push }                                     from '@ionic-native/push';

import { CommonProvider }                           from '../providers/common/common';
import { SplitPaneProvider }                        from '../providers/split-pane/split-pane';
import { AuthServiceProvider }                      from '../providers/auth-service/auth-service';
import { ConcorrenciaProvider }                     from '../providers/concorrencia/concorrencia';
import { CategoryMlProvider }                       from '../providers/category-ml/category-ml';
import { DataServiceProvider }                      from '../providers/data-service/data-service';
import { GeralVendasProvider }                      from '../providers/geral-vendas/geral-vendas';
import { NovosNegociosProvider }                    from '../providers/novos-negocios/novos-negocios';
import { ShoppingPrecoProvider }                    from '../providers/shopping-preco/shopping-preco';
import { NovosKitsProvider }                        from '../providers/novos-kits/novos-kits';
import { ChecklistProvider }                        from '../providers/checklist/checklist';

import { registerLocaleData }                       from '@angular/common';
import   localePt                                   from '@angular/common/locales/pt';
import { UsoProvider }                              from '../providers/uso/uso';
import { AudioProvider }                            from '../providers/audio/audio';

import { NativeAudio }                              from '@ionic-native/native-audio/ngx';
import { RelacaoProvider }                          from '../providers/relacao/relacao';


registerLocaleData(localePt);

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp),
    NgDatepickerModule,
    TooltipsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
                       Push,
                  StatusBar,
                NativeAudio,
               SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
       { provide: LOCALE_ID, useValue: 'pt-BR' },
             CommonProvider,
          SplitPaneProvider,
        AuthServiceProvider,
       ConcorrenciaProvider,
         CategoryMlProvider,
        DataServiceProvider,
        GeralVendasProvider,
      NovosNegociosProvider,
      ShoppingPrecoProvider,
          NovosKitsProvider,
          ChecklistProvider,
                UsoProvider,
              AudioProvider,
            RelacaoProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts